export class ApagosFailure {
    static PIECE_SHOULD_MOVE_DOWNWARD = () => $localize `Pieces should only move downward!`;
    static CANNOT_LAND_ON_A_FULL_SQUARE = () => $localize `That square is already full, you cannot put a piece in it!`;
    static NO_PIECE_OF_YOU_IN_CHOSEN_SQUARE = () => $localize `You have no pieces in that square, select one that contains at least one of your pieces!`;
    static NO_PIECE_REMAINING_TO_DROP = () => $localize `There are no remaining pieces of that color to drop!`;
    static NO_POSSIBLE_TRANSFER_REMAINS = () => $localize `There is no possible transfer from that square!`;
}
